import React from 'react';
import InboxIcon from '@material-ui/icons/Inbox';
import HomeIcon from '@material-ui/icons/Home';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import SettingsIcon from '@material-ui/icons/Settings';

interface MainMenuItemProps {
    label: string;
    path: string;
    icon?: any;
}

export const mainMenuItem: MainMenuItemProps[] = [
    {
        label: 'settings',
        path: 'options',
        icon: <SettingsIcon/>
    },
    {
        label: 'inputs',
        path: 'device',
        icon: <HomeIcon/>
    },
    {
        label: 'alarms',
        path: 'alarms',
        icon: <NotificationsActiveIcon/>
    },
    {
        label: 'rotation',
        path: 'rotation',
        icon: <InboxIcon/>
    }
];